import {Reducer} from 'redux'
import {TabsActionTypes, TabsState} from './types';
import {Tab} from "../../tabs/Tab";
import {Utility} from "../../core/Utility";

// Type-safe initialState!
const initialState: TabsState = {
	active: null,
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<TabsState> = (state = initialState, action) => {
	switch (action.type) {
		case TabsActionTypes.ADD: {
			let newTab: Tab = action.payload
			let tabs = [ ...state.list ]
			let newRang: number = 0;

			if(tabs.length) {

				let tabsCopy = Utility.clone(tabs);
				let tabsSortedByRang = tabsCopy.sort((a, b) => a.rang - b.rang);
				let highestRang: number = tabsSortedByRang[tabsSortedByRang.length - 1].rang;
				newRang = highestRang + 1;
			}

			newTab.rang = newRang
			let activeTab = newTab

			// todo: move this logic into the service
			if (newTab.type.multiple) tabs.push(newTab)
			else {
				// check for tab with id - existing item
				if (newTab.item && newTab.item.id) {
					let index = state.list.findIndex((t: Tab) => {return t.item && t.item.id == newTab.item.id})
					if (index == -1) {
						tabs.push(newTab)
					}
					else {
						activeTab = state.list[index]
					}
				}
				// check tab with type - new item
				else if (newTab.item) {
					let index = state.list.findIndex((t: Tab) => {
						return (t.type.key == newTab.type.key) && !t.item.id
					})
					if (index == -1) {
						tabs.push(newTab)
					}
					else {
						activeTab = state.list[index]
					}
					// tabs.push(newTab)
				}
				// check tab for lists
				// todo: if it is the same as previous make code simpler
				else {
					let index = state.list.findIndex((t: Tab) => {
						return t.type.key == newTab.type.key
					})
					if (index == -1) {
						tabs.push(newTab)
					}
					else {
						activeTab = state.list[index]
					}
				}
			}

			return { ...state, list: tabs, active: activeTab };
		}
		case TabsActionTypes.DELETE: {
			let tabToRemove:Tab = action.payload
			let newTabList = state.list.filter((tab: Tab) => tab.id !== tabToRemove.id)
			let newTabListCopy = Utility.clone(newTabList);
			let tabsSortedByRang = newTabListCopy.sort((a, b) => a.rang - b.rang)
			let prevActive = tabsSortedByRang[tabsSortedByRang.length - 1]
			let newActive = newTabList.length ? prevActive : null
			return { ...state, list: [...newTabList], active: newActive }
		}
		case TabsActionTypes.DELETE_FOR_ITEM: {
			let id :string = action.payload
			let newTabList = state.list.filter((tab: Tab) => {
				return !tab.item || tab.item.id != id
			})
			let newActive = state.active
			if (state.active.item && state.active.item.id == id) newActive = newTabList.length ? newTabList[0] : null
			return { ...state, list: [...newTabList], active: newActive}
		}
		case TabsActionTypes.SET_ACTIVE: {
			let activeTab = action.payload
			let tabs = [ ...state.list ]
			let tabsSortedByRang = tabs.sort((a, b) => a.rang - b.rang);
			let highestRang: number = tabsSortedByRang[tabsSortedByRang.length - 1].rang;
			activeTab.rang = highestRang + 1;
			return {...state, active: activeTab}
		}
		case TabsActionTypes.SET_TAB_STATE: {
			let newState = action.payload
			// todo: move to some helper or service or...
			let tabToChange = state.list.find((t: Tab) => t.id == state.active.id)
			tabToChange.state = {...newState}
			return {...state, list: state.list, active: tabToChange}
		}
		case TabsActionTypes.SET_TAB_STATE_ITEM: {
			let newStateItem = action.payload
			// todo: move to some helper or service or...
			let tabToChange = state.list.find((t: Tab) => t.id == state.active.id)
			// tabToChange.state.item = {...newStateItem}
			tabToChange.state.item = Utility.clone(newStateItem)
			return {...state, active: {...tabToChange}}
		}
		case TabsActionTypes.SET_TAB_ITEM: {
			let newItem = action.payload
			// todo: move to some helper or service or...
			let tabToChange = state.list.find((t: Tab) => t.id == state.active.id)
			tabToChange.item = Utility.clone(newItem)
			return {...state, list: state.list, active: {...tabToChange}}
		}
		case TabsActionTypes.SET_TAB_ITEM_FOR_TAB_ID: {
			let newItem = action.payload.item
			let tabId = action.payload.tabId
			// todo: move to some helper or service or...
			let tabToChange = state.list.find((t: Tab) => t.id == tabId)
			tabToChange.item = Utility.clone(newItem)
			let activeTab = state.active
			if (tabId == activeTab.id) activeTab = tabToChange
			return {...state, list: state.list, active: activeTab}
		}
		case TabsActionTypes.UPDATE_TAB_STATE_ITEM: {
			let {item, elementName, index} = action.payload
			// todo: move to some helper or service or...
			let tabToChange = state.list.find((t: Tab) => t.id == state.active.id)
			if (tabToChange.state.item[elementName]) {
				if (!tabToChange.state.item[elementName][index]) tabToChange.state.item[elementName].push(item)
				else {
					tabToChange.state.item[elementName][index] = item
				}
			}
			tabToChange = Utility.clone(tabToChange)
			return {...state, list: state.list, active: tabToChange}
		}
		case TabsActionTypes.SET_ACTIVE_TAB_TITLE: {
			let title = action.payload
			// todo: move to some helper or service or...
			let tabToChange = state.list.find((t: Tab) => t.id == state.active.id)
			tabToChange.title = title
			return {...state, list: [...state.list]}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as TabsReducer}

const clone = (obj: any) => {
	if (null == obj || "object" != typeof obj) return obj;
	var copy = obj.constructor();
	for (var attr in obj) {
		if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
	}
	return copy;
}
